import { Button, Colors, Text, View } from 'react-native-ui-lib';
import {
  convertPathToInfo,
  convertRouteParamsToInfo,
} from '../helperFunctions';
import { Statement } from './Containers';
import { FirestoreConstants, navigationProps, ElementPath } from '../typings/types';
import { FlatList, ScrollView } from 'react-native';
import React, { useEffect, useState } from 'react';
import {
  useFocusEffect,
} from '@react-navigation/native';
import { useIsMobile } from '../MediaQueries';
import { strings } from '../localization/localization.web';
import { Footer } from './Footer';
import { DocumentData, doc, getDoc, getFirestore } from 'firebase/firestore';
import { showLinkDialog } from './Dialogs';
import exampleArticleImage1 from '../../assets/res/exampleArticleImage1.png';
import exampleArticleImage2 from '../../assets/res/exampleArticleImage2.png';
import exampleArticleImage3 from '../../assets/res/exampleArticleImage3.png';
import { Image } from 'react-native';
import { GeneratedBadge } from './Badges';
import { CoursesTeaser } from './CoursesTeaser';

export function SourceScreen({
  navigation,
  route,
}: navigationProps): JSX.Element {
  const parentInfo: ElementPath = convertRouteParamsToInfo(route.params) as ElementPath;
  const [transitionFinished, setTransitionFinished] = useState(false);
  const isMobile = useIsMobile();
  const [sourceData, setSourceData] = React.useState<DocumentData>();

  useFocusEffect(() => {
    if (!transitionFinished) {
      setTransitionFinished(true);
    }
  });

  useEffect(() => {
    const documentReference = doc(getFirestore(), FirestoreConstants.SOURCES, route.params.id);
    getDoc(documentReference).then((documentSnapshot) => {
      if (documentSnapshot.exists()) {
        // console.log('Document data:', documentSnapshot.data());
        setSourceData(documentSnapshot.data());
      } else {
        console.log('No such document!');
      }
    }).catch((error) => {
      console.log('Error getting document:', error);
    });
  }, []);

  function getDomain(url: string): string {
    if (!url) {
      return '';
    }
    const regex = /^(?:https?:\/\/)?(?:www\.)?([^\/]+)/;
    const match = url.match(regex);
    return match ? match[1] : null;
  }

  function getRandomExampleImage(): any {
    const images = [exampleArticleImage1, exampleArticleImage2, exampleArticleImage3];
    return images[Math.floor(Math.random() * images.length)];
  }

  return (
    <View
      testID="source-screen"
      flex
      style={{
        backgroundColor: Colors.primaryBG
      }}
    >
      <View flex
        style={{
          backgroundColor: isMobile ? 'transparent' : Colors.secondaryBG,
          borderRadius: 20,
          marginHorizontal: isMobile ? 0 : 5,
          marginVertical: 5,
          overflow: 'hidden',
        }}
      >
        {sourceData ?
          <View flex style={{ marginHorizontal: 10, marginVertical: 5, marginBottom: 0 }}>
            <View flex style={{ backgroundColor: 'transparent', borderRadius: 20, padding: 0 }}>
              <ScrollView showsVerticalScrollIndicator={false}>
                <Image
                  source={getRandomExampleImage()}
                  style={{
                    width: isMobile ? "100%" : '100%',
                    height: isMobile ? 200 : 350,
                    borderRadius: 10, opacity: 1,
                  }}
                />
                <Text marginT-4 marginB-4 textSecondary text70>
                  {strings.extracted_from + " "}
                  <Button link onPress={() => showLinkDialog(sourceData.url, strings)}>
                    <Text textSecondary text70>
                      {getDomain(sourceData.url)}
                    </Text>
                  </Button>
                </Text>
                <Text marginB-8 text50 style={{ color: Colors.textPrimary }}>
                  {sourceData.originalTitle}
                  {" "}
                  <GeneratedBadge />
                </Text>
                <CoursesTeaser navigation={navigation} testID="source-courses-teaser" />
                <View>
                  {sourceData.mainRelatedStatementsIds ?
                    <FlatList
                      data={sourceData.mainRelatedStatementsIds}
                      renderItem={({ item }) => (
                        <Statement
                          info={convertPathToInfo(item)}
                          parentInfo={parentInfo}
                          navigation={navigation}
                          showHeader={false}
                          lightweight
                          emphasize
                        />
                      )}
                      ItemSeparatorComponent={() =>
                        <View padding-2 />
                      }
                      ListFooterComponent={() =>
                        <View padding-5 row right>
                        </View>
                      }
                    />
                    : null
                  }
                  {sourceData.relatedStatementsIds ?
                    <FlatList
                      data={sourceData.relatedStatementsIds}
                      renderItem={({ item }) => (
                        <Statement
                          info={convertPathToInfo(item)}
                          parentInfo={parentInfo}
                          navigation={navigation}
                          showHeader={false}
                          lightweight
                        />
                      )}
                      ItemSeparatorComponent={() =>
                        <View padding-2 />
                      }
                      ListFooterComponent={() =>
                        <Footer navigation={navigation} />
                      }
                      ListHeaderComponent={() =>
                        <Text marginT-4 marginB-6 text65 style={{ color: Colors.textPrimary }}>
                          {strings.all_statements}
                        </Text>
                      }
                    />
                    : null
                  }
                </View>
              </ScrollView>
            </View>
          </View>
          : null
        }
      </View>
    </View>
  );
}